export default "__VITE_ASSET__DzAd0SIo__"